import styles from "../../pages/GSTReconciliation/GSTReconciliation.module.scss";

export default function GSTApiAccessStep() {
  return (
    <div className={styles.apiSetupSteps}>
      <div className={styles.apiSetupStep}>
        <div className={styles.apiStepNum}>1</div>
        <div className={styles.apiStepContent}>
          <div className={styles.apiStepTitle}>Open GST Portal</div>
          <div className={styles.apiStepDesc}>Log in with the GSTIN's portal username.</div>
        </div>
      </div>
      <div className={styles.apiSetupStep}>
        <div className={styles.apiStepNum}>2</div>
        <div className={styles.apiStepContent}>
          <div className={styles.apiStepTitle}>Go to API access</div>
          <div className={styles.apiStepDesc}>Open My Profile → Manage API Access.</div>
        </div>
      </div>
      <div className={styles.apiSetupStep}>
        <div className={styles.apiStepNum}>3</div>
        <div className={styles.apiStepContent}>
          <div className={styles.apiStepTitle}>Enable access</div>
          <div className={styles.apiStepDesc}>
            Choose "Yes" for API access and save. Then return to Merito and request OTP.
          </div>
        </div>
      </div>
    </div>
  );
}
